import { render, staticRenderFns } from "./price-display.vue?vue&type=template&id=b7c093e4"
import script from "./price-display.vue?vue&type=script&lang=js"
export * from "./price-display.vue?vue&type=script&lang=js"
import style0 from "./price-display.vue?vue&type=style&index=0&id=b7c093e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports